<div class="document-upload-container mat-elevation-z8">
  <h2>{{ metadata.title }}</h2>
  <p>{{ metadata.description }}</p>

  <!-- Loading Spinner -->
  <div *ngIf="loading" class="loading-container">
    <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
    <p>Loading documents...</p>
  </div>

  <!-- Show existing documents if already uploaded -->
  <div *ngIf="!loading && hasExistingDocuments()" class="existing-documents">
    <div class="success-message">
      <span class="checkmark">&#10003;</span>
      <span>Documents already uploaded</span>
    </div>

    <div class="documents-list">
      <div *ngFor="let doc of existingDocuments" class="document-item">
        <div class="document-icon">
          <span *ngIf="doc.isImage">&#128247;</span>
          <span *ngIf="doc.isPdf">&#128196;</span>
        </div>
        <div class="document-details">
          <span class="document-name">{{ doc.fileName || doc.description }}</span>
          <span class="document-date">Uploaded: {{ formatDate(doc.uploadDate) }}</span>
        </div>
      </div>
    </div>

    <p class="update-info">Need to update your documents? Upload new files below:</p>
  </div>

  <!-- Upload form (always shown, but with different context) -->
  <form *ngIf="!loading" [formGroup]="documentUploadForm" class="document-upload-form">
    <div *ngFor="let field of fields" class="document-upload-field">
      <label>{{ field.label }}</label>
        <input
          type="file"
          (change)="onFileChange($event, field.name)"
          [required]="field.required && !hasExistingDocuments()"
          class="file-input"
          [accept]="getAcceptedFileTypes(field.type)"
        />
      <small class="help-text">{{ field.helpText }}</small>
      <div *ngIf="documentUploadForm.get(field.name)?.touched && documentUploadForm.get(field.name)?.invalid" class="error-text">
        {{ field.validationMessage }}
      </div>

      <!-- Display File Name -->
      <div *ngIf="documentUploadForm.get(field.name)?.value" class="file-info">
        <strong>Selected File:</strong> {{ documentUploadForm.get(field.name)?.value.name }}
      </div>

      <!-- Display Processing Status -->
      <div *ngIf="fileStatus[field.name] === 'processing'" class="file-status processing">
        <span>Processing...</span>
        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
      </div>

      <!-- Display Uploading Status -->
      <div *ngIf="fileStatus[field.name] === 'uploading'" class="file-status uploading">
        <span>Uploading...</span>
        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
      </div>

      <!-- Display Upload Status -->
      <div *ngIf="fileStatus[field.name] === 'uploaded'" class="file-status success">
        <span>&#10003; Uploaded</span>
      </div>
      <div *ngIf="fileStatus[field.name] === 'failed'" class="file-status error">
        <span>&#10060; Upload Failed</span>
      </div>

    </div>

    <div class="actions">
      <button mat-raised-button color="primary" (click)="uploadFiles()" [disabled]="isUploading() || !hasFiles()">
        <mat-progress-spinner *ngIf="uploading" diameter="18" mode="indeterminate" class="button-spinner"></mat-progress-spinner>
        <span *ngIf="!uploading">{{ hasExistingDocuments() ? 'Update Documents' : 'Upload' }}</span>
        <span *ngIf="uploading">Uploading...</span>
      </button>
      <button mat-raised-button color="warn" (click)="clearAll()" [disabled]="!hasFiles() || uploading">
        Clear
      </button>
    </div>
  </form>
</div>
